import { render, staticRenderFns } from "./AppRedirect.vue?vue&type=template&id=79eef631&"
import script from "./AppRedirect.vue?vue&type=script&lang=js&"
export * from "./AppRedirect.vue?vue&type=script&lang=js&"
import style0 from "./AppRedirect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
